module.exports = __webpack_public_path__ + "img/Gerümpel.b92b498c.jpg";